module.exports = __webpack_public_path__ + "img/p_icon09.e2f0742b.svg";